import { injectGlobal } from 'styled-components';
import { colors } from './colors';
import { defaults } from './defaults';
import { fastclick } from './fastclick';
import { flagIconFont } from './flagIconFont';
import { fonts } from './fonts';
import { grid } from './grid';
import { iconFont } from './iconFont';
import { resets } from './resets';
import { tables } from './tables';
import { transitions } from './transitions';
import { userCentrics } from './userCentrics';

// Embed fonts directly to avoid flickering when styled components updates its style tags
const styleTag = document.createElement('style');
styleTag.innerText = `
  ${fonts}
  ${iconFont}
  ${flagIconFont}
`;
document.head.appendChild(styleTag);

injectGlobal`${resets}`;
injectGlobal`${fastclick}`;
injectGlobal`${transitions}`;
injectGlobal`${tables}`;
// tslint:disable-next-line:no-unused-expression
injectGlobal`${userCentrics}`;

const base = {
  colors: { ...colors },
  defaults: { ...defaults },
  grid: { ...grid }
};

export default base;
